/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
import { useEffect, useState } from "react";
// import { IsPc } from "../utils/index";
import Style from "./index.module.scss"
import "moment/locale/zh-cn";
import { useLocation, useParams } from "react-router-dom";
// import { IsPc } from "../../../utils/index";
// import { Modal } from "antd"
import { get } from "../../../component/fetch"
// import { MenuUnfoldOutlined, CopyOutlined, PlayCircleFilled } from "@ant-design/icons"


export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
const Index = () => {
    // const history = useHistory();
    // const query = useQuery()
    const routeParam: any = useParams()
    const { contentId } = routeParam
    // const subjectId = query.get('subjectId')
    const [contentInfo, setContentInfo] = useState({})
    // const [recommendList,setRecommendList] = useState([])
    const getDetail = () => {
        get('/shop/front/ge/column/subject/content/getDetail?contentId=' + contentId, {}, false).then(res => {
            setContentInfo(res.data)
        })
    }
    // const getTuijianList= () => {
    //     post('/shop/front/ge/column/getSubjectJoinContentList',{
    //         contentId,
    //         subjectId,
    //     },false).then(res=>{
    //         // setRecommendList(res.data.list)
    //     })
    // }
    useEffect(() => {
        getDetail()
        // getTuijianList()
    }, [contentId])
    return (
        <div className={Style.recommend}>
            <h1>{contentInfo.titleName}</h1>
            {/* <div className={Style.content}>
                <p >
                    <img className={Style.logo} src={contentInfo.logoUrl} alt=""></img>
                </p>
            </div> */}
            <div dangerouslySetInnerHTML={{ __html: contentInfo.contentInfo }}></div>
            <div style={{ minHeight: "300PX",marginTop:"20px" }}>
                  <span>阅读：{contentInfo.pv}</span>
             </div>
            {/* <div className={Style.title}>
                <CopyOutlined /><span style={{ marginLeft: "10px" }}>推荐内容</span>
            </div>
            <div style={{display:"flex",flexWrap:"wrap",justifyContent:"space-between",margin:"20px 0"}}>
                {recommendList.map((item:any,index:number)=>{
                    return <div className={Style.recommendItem} key={index} onClick={()=>{
                        history.push(`/recommend/${item.id}?subjectId=${subjectId}`)
                    }}>
                        <img src={item.logoUrl} alt=""/>
                        <p>{item.titleName}</p>
                    </div>
                })}
            </div> */}
        </div>
    );
};

export default Index;
